import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a corner shower stall 0.9 x 0.9 x 2.1 m: shallow white
// tray, two solid plaster panels on the back corner (-X / -Z), two framed
// glass panels on the open sides (+X / +Z) and a steel riser pipe + shower
// head in the back corner.
const TRAY = "#f2f0ea";
const TILE = "#e8e4dc";
const GLASS = "#9fc4d4";
const FRAME = "#2e2e30";
const STEEL = "#aab2b8";

export const showerStall = defineModel({
  id: "shower-stall",
  batchId: "modern",
  name: "Shower stall",
  tags: ["modern", "interior", "fixture", "bathroom", "shower"],
  summary: "A corner shower stall with glass panels and a steel shower head.",
  tiles: { w: 1, h: 1 },
  footprint: 1.2,
  parts(): Part[] {
    return [
      // shallow tray
      { geometry: new THREE.BoxGeometry(0.9, 0.1, 0.9), color: TRAY, position: [0, 0.05, 0] },
      // solid back panels (tiled look) on the -Z and -X edges
      { geometry: new THREE.BoxGeometry(0.9, 2.0, 0.05), color: TILE, position: [0, 1.1, -0.425] },
      { geometry: new THREE.BoxGeometry(0.05, 2.0, 0.85), color: TILE, position: [-0.425, 1.1, 0.025] },
      // glass panels on the open +Z and +X edges
      { geometry: new THREE.BoxGeometry(0.82, 1.86, 0.02), color: GLASS, position: [-0.02, 1.05, 0.42] },
      { geometry: new THREE.BoxGeometry(0.02, 1.86, 0.82), color: GLASS, position: [0.42, 1.05, -0.02] },
      // thin matte-black frames: corner post and top rails
      { geometry: new THREE.BoxGeometry(0.04, 1.9, 0.04), color: FRAME, position: [0.42, 1.05, 0.42] },
      { geometry: new THREE.BoxGeometry(0.88, 0.04, 0.04), color: FRAME, position: [-0.02, 2.0, 0.42] },
      { geometry: new THREE.BoxGeometry(0.04, 0.04, 0.88), color: FRAME, position: [0.42, 2.0, -0.02] },
      // riser pipe in the back corner
      { geometry: new THREE.CylinderGeometry(0.015, 0.015, 1.1, 8), color: STEEL, position: [-0.34, 1.35, -0.34] },
      // shower arm reaching out of the corner
      {
        geometry: new THREE.BoxGeometry(0.03, 0.03, 0.18),
        color: STEEL,
        position: [-0.3, 1.92, -0.27],
        rotation: [0, Math.PI / 4, 0],
      },
      // shower head disc
      {
        geometry: new THREE.CylinderGeometry(0.08, 0.08, 0.025, 12),
        color: STEEL,
        position: [-0.24, 1.9, -0.21],
      },
    ];
  },
  animations: [],
});
